import React, { Component } from 'react';
import CvCompleteView from './CvCompleteView';
import moment from 'moment';
import { url } from '../../../Server/url/GlobalUrl';

class CvCompleteComponent extends Component {
  state = {
    perssonal_detail: '',
    file_name: '',
    title_type: '',
    right_to_work_selected: '',
    formated_date: '',
    profile_name: '',
  };

  componentDidMount() {
    console.log('cv-id', sessionStorage.getItem('cv-id'));
    let id = localStorage.getItem('cv-id-preview');
    id = id ? id : localStorage.getItem('cv-id');

    fetch(url + '/api/v1/user/submit-details/' + id + '/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('resukt', result);
          this.setState({ perssonal_detail: result });
          var day = moment(result.date_of_birth).format('MMMM DD, YYYY');
          this.setState({ formated_date: day });
          if (result.filepath) {
            var uri = result.filepath.split('/').pop();
            this.setState({ file_name: uri });
            if (result.profile_picture) {
              uri = result.profile_picture.split('/').pop();
              this.setState({ profile_name: uri });
            }
          }

          fetch(url + '/api/v1/user/title/' + result.title + '/', {
            method: 'GET',
          })
            .then((res) => res.json())
            .then(
              (result) => {
                this.setState({ title_type: result.type });
                console.log('result', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
          fetch(
            url + '/api/v1/user/right-to-work/' + result.right_to_work + '/',
            {
              method: 'GET',
            }
          )
            .then((res) => res.json())
            .then(
              (result) => {
                this.setState({ right_to_work_selected: result.type });
                console.log('result', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
        },
        (error) => {
          console.log('error', error);
        }
      );
    localStorage.removeItem('cv-id-preview');
  }

  render() {
    return (
      <CvCompleteView
        perssonal_detail={this.state.perssonal_detail}
        file_name={this.state.file_name}
        title_type={this.state.title_type}
        right_to_work_selected={this.state.right_to_work_selected}
        formated_date={this.state.formated_date}
        profile_name={this.state.profile_name}
      />
    );
  }
}

export default CvCompleteComponent;
